import { useEffect, useRef } from 'react'

import { useLocation } from 'Pods/Shared/ContextBasedRouter'
import usePageConfig from 'Pods/Shared/Hooks/usePageConfig'
import { setIsSidebarOpen } from 'Pods/ThreeDStudio/Store/actions/ui'

import { getBreakPoint } from 'Utils/useBreakpoint'

// On mobile (< 640px) the open library sidebar covers the workspace, hiding the
// studio behind the model card list. Collapse the sidebar once on initial load
// so mobile users land on the workspace: /ai opens on Generate (the default
// panel) and /ai-3d-model-generator/3d-models/<slug> opens on the model viewer. The exact
// community gallery routes (/ai-3d-model-generator/3d-models, /ai-image-generator/images)
// keep their list. Desktop is untouched.
function useInitialMobilePanel({ extractingCoreStyles = false } = {}) {
  const location = useLocation()
  const pathname = location?.pathname ?? ''
  // Only the exact community gallery routes keep the open list; their sub-paths
  // render the workspace and should collapse the sidebar.
  const isGalleryRoute = pathname === '/ai-3d-model-generator/3d-models'
    || pathname === '/ai-3d-model-generator/3d-models/'
    || pathname === '/ai-image-generator/images'
    || pathname === '/ai-image-generator/images/'

  const pageConfig = usePageConfig()
  const pageConfigLoaded = pageConfig !== undefined

  const hasRunRef = useRef(false)

  useEffect(() => {
    if (hasRunRef.current || extractingCoreStyles || isGalleryRoute || !pageConfigLoaded) {
      return
    }

    hasRunRef.current = true

    if (getBreakPoint(window.innerWidth) === 'xs') {
      setIsSidebarOpen(false)
    }
  }, [
    extractingCoreStyles,
    isGalleryRoute,
    pageConfigLoaded,
  ])
}

export default useInitialMobilePanel
